(function() {
    'use strict'

    var pluginName = "headScroller";
    var defaults = {

    };

    // Plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.options = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    // Plugin Methods
    Plugin.prototype = {
        checkMedia: function() {
            if (window.matchMedia) {
                if (window.matchMedia('only screen and (min-width: 900px)').matches) {
                    this.data.headerH = $('.js-header').outerHeight();
                    this.data.menulogoH = this.$menulogo.outerHeight();
                    this.data.menulogoW = this.$menulogo.outerWidth();
                    this.data.logoFontW = this.$logo.outerWidth();
                    this.data.winInnerHeight = window.innerHeight;
                    this.data.logoRatio = this.data.menulogoH / this.data.menulogoW
                    this.data.logoW = this.data.logoFontW - (this.data.logoFontW * this.data.logoPadding)
                    this.data.logoH = this.data.logoW * this.data.logoRatio;
                    this.data.maxTop = (this.data.headerH / 2) + (this.data.menulogoH / 2);
                    if (!this.eventsBinded) {
                        this.bindEvents();
                    }
                }
            }
        },

        init: function() {
            this.$element = $(this.element);
            this.$body = $('body');
            this.$logo = $('.js-reel-logo svg');
            this.logo = this.$logo.get(0);
            this.$menulogo = $('.js-menu-logo');
            this.$menu = $('.js-menu');
            this.$headerbar = $('.js-header')
            this.data = {
                logoPadding: 0.2451
            };
            this.eventsBinded = false;

            this.bindResize();
            this.checkMedia();
        },

        calcValues: function() {
            let winPercentScrolled = window.scrollY / (this.data.winInnerHeight - this.data.headerH);

            this.data.logoY = this.logo.getBoundingClientRect().top;
            this.data.passed = this.data.headerH - this.data.logoY;
            if (this.data.passed < 0) {
                this.data.passed = 0;
            }

            if (this.data.passed > 0) {
                this.data.percent = 100 / (this.data.logoH / this.data.passed);
            }
            else {
                this.data.percent = 0;
            }

            $('.js-reel-video').trigger('setPlayerVolume', {scrolled: winPercentScrolled});
            this.animate();
        },

        animate: function() {
            const val = (this.data.percent > 100)? 100 : this.data.percent;
            let topVal = (this.data.percent / 100) * this.data.menulogoH;
            if (topVal > this.data.maxTop) {
                topVal = this.data.maxTop;
            }

            if (val > 2) this.$body.attr('data-scrolled', true);
            else this.$body.attr('data-scrolled', false);
            this.$menu.css({
                transform: 'translate(-50%, -' + topVal + 'px)'
            });

            if (topVal >= this.data.maxTop) {
                this.$menu.addClass('is-ready');
            }
            else {
                this.$menu.removeClass('is-ready');
            }
        },

        scroll: function(e) {
            if (window.requestAnimationFrame) {
                window.requestAnimationFrame(this.calcValues.bind(this));
            }
        },

        // EVENTS
        bindEvents: function() {
            this.eventsBinded = true;
            this.$element.on('scroll', this.scroll.bind(this));
        },

        bindResize: function() {
            this.$element.on('resize', this.checkMedia.bind(this));
        }
    };

    // Plugin wrapper
    $.fn[pluginName] = function(options) {
        return this.each(function() {
            if(!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
    }
}());
